import moment from "moment";

const BotFlowStepsView = ({ steps }) => {
  const renderStep = (step, index) => {
    return (
      <div key={step.stepKey || index} className="mb-6">
        <div className="flex flex-col items-start mb-3">
          <div className="text-sm text-gray-500 font-medium mb-2">Support</div>
          <div className="bg-gray-100 rounded-2xl rounded-tl-md px-4 py-3 max-w-[80%]">
            <p className="text-gray-800 text-sm leading-relaxed">
              {step.question}
            </p>
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {moment(step.at).format("DD.MM.YYYY hh:mm A")}
          </div>
        </div>

        {step.options && (
          <div className="ml-0 mb-4">
            <div className="flex flex-col gap-2 max-w-[80%]">
              {step.options.map((option, idx) => (
                <div
                  key={idx}
                  className={`px-3 py-2 rounded-lg text-sm transition-all duration-200 border ${
                    option === step.answer
                      ? "bg-blue-50 border-blue-200 text-blue-700"
                      : "bg-white border-gray-200 text-gray-600"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span>{option}</span>
                    {option === step.answer && (
                      <span className="text-blue-500">✓</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {step.answer && (
          <div className="flex flex-col items-end mb-4">
            <div className="text-sm text-gray-500 font-medium mb-2 self-end">
              You
            </div>
            <div className="bg-green-100 rounded-2xl rounded-tr-md px-4 py-3 max-w-[80%]">
              <p className="text-gray-800 text-sm leading-relaxed">
                {step.answer}
              </p>
            </div>
            <div className="text-xs text-gray-400 mt-1">
              {moment(step.at).format("DD.MM.YYYY hh:mm A")}
            </div>
          </div>
        )}
      </div>
    );
  };

  return <>{steps.map((step, index) => renderStep(step, index))}</>;
};
export default BotFlowStepsView;
